import * as React from 'react';
import { compose } from 'recompose';
import { LoggedInUserProps, withLoggedInUser } from '../Login/withLoggedInUser';
import { preloadActivityChart } from '../Strava/ActivityScene/ActivityChart/LazyActivityChart';
import { preloadActivityMap } from '../Strava/ActivityScene/ActivityMap/LazyActivityMap';
import { fetchDemoActivityListFirstPage } from '../Strava/Demo/withDemoActivityList';
import { fetchActivityListFirstPage } from '../Strava/withActivityList';
import { fetchAthlete } from '../Strava/withAthlete';
import { CompositeComponent } from '../types';

/**
 * Fetches application data and lazy loaded scripts for the current user,
 * or demo data if the user is not logged in
 */
const withPreloadContentCore = <TProps extends {}>(
    InnerComponent: CompositeComponent<LoggedInUserProps & TProps>
) => {
    return class PreloadContentComponent extends React.Component<
        LoggedInUserProps
    > {
        private fetchedData = false;

        public constructor(props: LoggedInUserProps) {
            super(props);
            this.fetchData = this.fetchData.bind(this);
        }

        public async componentDidMount() {
            await Promise.all([
                preloadActivityMap(),
                preloadActivityChart(),
                this.fetchData()
            ]);
        }

        public async componentDidUpdate() {
            await this.fetchData();
        }

        public render() {
            return <InnerComponent {...this.props} />;
        }

        private async fetchData() {
            // Only fetch data in the browser, and only do it once
            if ((process as any).browser && !this.fetchedData) {
                try {
                    if (this.props.loggedInUser) {
                        // Get athlete details and the first page of activities
                        // if the user is logged in.
                        // Running the two queries concurrently means Apollo should batch them into one http call.
                        await Promise.all([
                            fetchAthlete(),
                            fetchActivityListFirstPage()
                        ]);
                    } else {
                        // Otherwise get the first page of example activities
                        await fetchDemoActivityListFirstPage();
                    }
                } catch (err) {
                    // Eat the error, the apollo error handler
                    // will already have handled it
                    // tslint:disable-next-line:no-console
                    console.log('Error fetching data');
                }
                this.fetchedData = true;
            }
        }
    };
};

/**
 * Fetches application data and lazy loaded scripts for the current user,
 * or demo data if the user is not logged in
 */
export default compose<LoggedInUserProps, {}>(
    withLoggedInUser,
    withPreloadContentCore
);



// WEBPACK FOOTER //
// ./src/client/components/Home/withPreloadContent.tsx